import AboutMe from "../AboutMe";
import Experience from "../Experience";
import MainSection from "../MainSection";

export default function Home () {
    return(
        <>
            <MainSection />
            <Experience />
            <AboutMe />
        </>
    );
}